<template>
<div class="chapter">
<div class="inner_page">
<p class="P_Frontbmatterbheads">Contents</p>
<p class="P_TOCbChapterbtitle"><a class="hlink" href="#/OEBPS/c01.htm">Culinary Stencils</a></p>
<p class="P_TOCbChapterbtitle"><a class="hlink" href="#/OEBPS/c02.htm">Using Edible Dusts</a></p>
<p class="P_TOCbmiscbhead"><a class="hlink" href="#/OEBPS/c02.htm#sec1">METALLIC LUSTRE DUSTS</a></p>
<p class="P_TOCbmiscbhead"><a class="hlink" href="#/OEBPS/c02.htm#sec2">MATT DUSTS</a></p>
<p class="P_TOCbmiscbhead"><a class="hlink" href="#/OEBPS/c02.htm#sec3">MULTICOLOUR MATT DUSTS</a></p>
<p class="P_TOCbChapterbtitle"><a class="hlink" href="#/OEBPS/c03.htm">Using Royal Icing</a></p>
<p class="P_TOCbmiscbhead"><a class="hlink" href="#/OEBPS/c03.htm#sec4">ON COOKIES</a></p>
<p class="P_TOCbmiscbhead"><a class="hlink" href="#/OEBPS/c03.htm#sec5">ON CUPCAKES</a></p>
<p class="P_TOCbmiscbhead"><a class="hlink" href="#/OEBPS/c03.htm#sec6">ON THE TOPS OF BOARDS AND CAKES</a></p>
<p class="P_TOCbmiscbhead"><a class="hlink" href="#/OEBPS/c03.htm#sec7">ON THE SIDES OF CAKES</a></p>
<p class="P_TOCbmiscbhead"><a class="hlink" href="#/OEBPS/c03.htm#sec8">MULTICOLOUR EFFECTS</a></p>
<p class="P_TOCbChapterbtitle"><a class="hlink" href="#/OEBPS/c04.htm">Adjusting a Stencil to Fit</a></p>
<p class="P_TOCbChapterbtitle"><a class="hlink" href="#/OEBPS/c05.htm">Adding Embellishments</a></p>
<p class="P_TOCbChapterbtitle"><a class="hlink" href="#/OEBPS/c06.htm">Making Your Own Stencil</a></p>
<p class="P_TOCbmiscbhead"><a class="hlink" href="#/OEBPS/c06.htm#sec9">USING READILY AVAILABLE MATERIALS</a></p>
<p class="P_TOCbmiscbhead"><a class="hlink" href="#/OEBPS/c06.htm#sec10">USING SPECIALIST TOOLS</a></p>
<p class="P_TOCbChapterbtitle"><a class="hlink" href="#/OEBPS/c07.htm">Other Uses for Stencils</a></p>
<div class="Image"><img alt="" src="OEBPS/images/2-1.jpg"/><br/><br/><br/></div>
<p class="P_CAPbimage">Stacked Hatboxes<br/>The beautiful, intricate patterns on these boxes are created simply using culinary stencils, royal icing and edible dusts.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?2faf3af4